import React from 'react'

interface DocumentGenerationIconProps {
  width?: number
  height?: number
  alt?: string
}

const DocumentGenerationIcon: React.FC<DocumentGenerationIconProps> = ({
  width = 24,
  height = 24,
  alt = 'Document generation icon',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      aria-label={alt}
    >
      <title>{alt}</title>
      <path
        d='M17.7139 2C18.2662 2 18.7139 2.44772 18.7139 3V11.0645C18.4819 11.0226 18.2431 11 17.999 11C15.7899 11 13.999 12.7909 13.999 15C13.999 16.0138 14.3773 16.9386 14.999 17.6436V20H6C5.44772 20 5 19.5523 5 19V3C5 2.44772 5.44772 2 6 2H17.7139ZM8 10.375C7.65482 10.375 7.375 10.6548 7.375 11C7.375 11.3452 7.65482 11.625 8 11.625H12.2773C12.6225 11.625 12.9023 11.3452 12.9023 11C12.9023 10.6548 12.6225 10.375 12.2773 10.375H8ZM8 7.375C7.65482 7.375 7.375 7.65482 7.375 8C7.375 8.34518 7.65482 8.625 8 8.625H16C16.3452 8.625 16.625 8.34518 16.625 8C16.625 7.65482 16.3452 7.375 16 7.375H8ZM8 4.375C7.65482 4.375 7.375 4.65482 7.375 5C7.375 5.34518 7.65482 5.625 8 5.625H15.7939C16.1389 5.62475 16.4189 5.34503 16.4189 5C16.4189 4.65497 16.1389 4.37525 15.7939 4.375H8Z'
        fill='#14146F'
      />
      <circle cx='18' cy='15' r='3' fill='#14146F' />
      <path
        d='M20 23L18 21.833L16 23V18.4629C16.5885 18.8035 17.2711 19 18 19C18.7289 19 19.4115 18.8035 20 18.4629V23Z'
        fill='#14146F'
      />
    </svg>
  )
}

export default DocumentGenerationIcon
